export const colors = {
  background: '#ffffff',

  black: '#000000',
  white: '#ffffff',
  grayLight: '#f3f4f4',
  blueBright: '#00a5ff',
  blueVeryLight: '#e5f4fb',
  blueLight: '#2ba8e0',
  blueMid: '#0099e0',
  blueDark: '#006196',

  success: '#05a34a',
  danger: '#e00808',
  warning: '#ff8200',

  border: '#d8d8d8',
  disabled: '#c8cbcc',
  shadow: '#2b404e',
  textPrimary: '#231f20',
  textSecondary: '#4a4a4a',
};

export const fontFamily = 'MarkPro';

export const lineHeight = '1.33333em';

export const defaultTextStyle = {
  fontFamily,
  lineHeight,
  color: colors.textPrimary,
  fontSize: '1em',
};

export const responsiveWidthBreakpoints = [
  768, // sm
  960, // md
];



// WEBPACK FOOTER //
// ./src/settings/theme.js